import { atomWithReset } from "jotai/utils";

import type { ClaimHistoryListItem } from "../dtos/get-claim-history-list-response-dto";

export type ClaimDeleteModalKind = "cancel" | "delete";

export const claimDeleteModalAtom = atomWithReset<{
  visible: boolean;
  claim: ClaimHistoryListItem | null;
  kind: ClaimDeleteModalKind;
}>({ visible: false, claim: null, kind: "delete" });
